
<div class="container mt-1">
  <div class="card shadow-sm">
    <div class="card-header bg-primary text-white d-flex justify-content-between align-items-center">
      <div>
        <h4 class="mb-0">Checker</h4>
        
      </div>
      <button class="btn btn-secondary btn-sm" (click)="back()">Back</button>
    </div>
    <div class="card-body">
      <form>
        <div class="mb-3 d-flex align-items-center">
          <label class="form-label me-3" style="width: 150px;">Employee ID</label>
          <!-- <select class="form-select" [(ngModel)]="checkerData.employeeid" name="employeeId" (change)="Onselectempolyee()">
            <option value="">Select Employee</option>
            <option *ngFor="let emp of employeeid" [value]="emp.OD_EmployeeID">{{ emp.OD_EmployeeID }}</option>
          </select> -->
        
          <input class="form-control" [(ngModel)]="checkerData.OD_EmployeeID" name="OD_EmployeeID" />
        
        </div>
        <div class="mb-3 d-flex align-items-center">
          <label class="form-label me-3" style="width: 150px;">First Name</label>
          <input class="form-control" [(ngModel)]="checkerData.firstName" name="firstName" />
        </div>
        <div class="mb-3 d-flex align-items-center">
          <label class="form-label me-3" style="width: 150px;">Last Name</label>
          <input class="form-control" [(ngModel)]="checkerData.lastName" name="lastName" />
        </div>
        <div class="mb-3 d-flex align-items-center">
          <label class="form-label me-3" style="width: 150px;">Designation</label>
          <input class="form-control" [(ngModel)]="checkerData.designation" name="designation" />
        </div>
        <div class="mb-3 d-flex align-items-center">
          <label class="form-label me-3" style="width: 150px;">Location</label>
          <input class="form-control" [(ngModel)]="checkerData.grade" name="grade" />
        </div>
        <div class="mb-3 d-flex align-items-center">
          <label class="form-label me-3" style="width: 150px;">Date of Joining</label>
          <input class="form-control" [(ngModel)]="checkerData.dateOfJoining" name="dateOfJoining" type="text" />
        </div>
        <div class="mb-3 d-flex align-items-center">
          <label class="form-label me-3" style="width: 150px;">Plant</label>
          <input class="form-control" [(ngModel)]="checkerData.plant" name="plant" />
        </div>
        <div class="mb-3 d-flex align-items-center">
          <label class="form-label me-3" style="width: 150px;">Department</label>
          <input class="form-control" [(ngModel)]="checkerData.department" name="department" />
        </div>
        <div class="mb-3 d-flex align-items-center" *ngIf="checkerData.OD_Account_type==='Role Change'">
 
          <label class="form-label me-3" style="width: 150px;">Further Department</label>
          <input class="form-control" [(ngModel)]="checkerData.Furtherdepartment" name="Furtherdepartment" />
        
        </div>
        <div class="mb-3 d-flex align-items-center">
          <label class="form-label me-3" style="width: 150px;">Requester</label>
          <input class="form-control" [(ngModel)]="checkerData.requester" name="requester" />
        </div>
        <div class="mb-3 d-flex align-items-center" *ngIf="appservice.editchecker==='rejected'">
  <label class="form-label me-3" style="width: 150px;">Comments</label>
  <textarea
  class="form-control"
  [(ngModel)]="checkerData.command"
  name="command"
  style="height: 50px;"
  placeholder="Reason">
</textarea>

</div>

        <div class="action-buttons d-flex justify-content-start gap-2 mt-3">
          <button class="btn btn-approve" type="button" (click)="onApprove()" *ngIf="appservice.checkereditdata.status === 'Approved'">Approve</button>
          <button class="btn btn-decline" type="button" (click)="onDecline()" *ngIf="appservice.checkereditdata.status === 'Rejected'">Decline</button>
        </div>
      </form>
    </div>
  </div>
</div>